import { render, staticRenderFns } from "./ServicePackages.vue?vue&type=template&id=201514e6&scoped=true"
import script from "./ServicePackages.vue?vue&type=script&lang=js"
export * from "./ServicePackages.vue?vue&type=script&lang=js"
import style0 from "./ServicePackages.vue?vue&type=style&index=0&id=201514e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201514e6",
  null
  
)

export default component.exports